import { gql } from "@apollo/client";

export const CREATE_SUNDRY_INVOICE = gql`
  mutation createSundryInvoice($bookingId: String!, $invoiceItems: [InvoiceItemInput]!, $notes: String, $documents:[InvoiceDocumentInput]) {
    createSundryInvoice(bookingId: $bookingId, invoiceItems: $invoiceItems, notes: $notes, documents:$documents) {
      id
    }
  }
`;